import * as React from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import Response from 'modules/reviews/components/Response'
import { ScoreProvider } from 'modules/reviews/lib/PerformanceScoreContext'
import type Review from 'modules/reviews/store/models/v2/Review'

const ReviewUserResponsePage = () => {
  const { review } = useOutletContext<{ review: Review }>()
  const { question_group_id } = useParams()

  return (
    <ScoreProvider>
      <Response form={review} questionGroupId={Number(question_group_id)} />
    </ScoreProvider>
  )
}

export default ReviewUserResponsePage
